/** @jsxImportSource theme-ui */
import { Button, Grid } from "@bottlebooks/gatsby-theme-base/src";
import { Trans } from "@lingui/macro";
import { InView } from "react-intersection-observer";

/**
 *
 * @param {{
 * children: React.ReactNode;
 * hasMore?: boolean;
 * showMore?: () => void;
 * width?: string | number;
 * [x: string]: any;
 * }} props
 * @returns
 */
export default function ProductsList({ children, hasMore, showMore, ...rest }) {
  return (
    <Grid width={300} repeat="fill" {...rest}>
      {children}
      {hasMore && showMore && (
        <InView
          onChange={(inView) => {
            if (inView) showMore();
          }}
          sx={{ marginTop: "-100vh", paddingTop: "100vh", gridColumn: "1/-1" }}
        >
          <Button variant="primary" onClick={showMore} sx={{ paddingY: 3 }}>
            <Trans>Show more</Trans>
          </Button>
        </InView>
      )}
    </Grid>
  );
}
